import { createSlice } from '@reduxjs/toolkit'
import { keyBy, sortByProp } from '../../../../../helpers/common'
import { register } from '../../../../../helpers/reducerRegistry'
import { SORT_DIRECTION } from '../../../../../utils/common'
import { schema } from '../constant'
import { getBusinessProvinceTable } from './thunk'

const slice = createSlice({
  name: 'companyAnalysis/industryOverview/businessProvince',
  initialState: {
    isLoading: true,
    data: {},
    ids: [],
    initialIds: [],
    sortTable: {
      sortBy: '',
      sortDirection: '',
    },
    dataRaw: [],
  },
  reducers: {
    resetStore: (state) => {
      state.isLoading = true
      state.data = {}
      state.ids = []
      state.initialIds = []
      state.sortTable = {
        sortBy: '',
        sortDirection: '',
      }
    },
    sort: (state, action) => {
      state.sortTable = action.payload

      if (action.payload.sortDirection) {
        state.ids = sortByProp(
          Object.values(state.data),
          action.payload.sortBy,
          action.payload.sortDirection === SORT_DIRECTION.DESC,
          [schema.provinceName.key, schema.region.key].includes(
            action.payload.sortBy,
          ),
        ).map((item) => item.id)
      } else {
        state.ids = state.initialIds
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBusinessProvinceTable.pending, (state) => {
      state.isLoading = true
      state.data = {}
      state.ids = []
      state.initialIds = []
      state.sortTable = {
        sortBy: '',
        sortDirection: '',
      }
    })
    builder.addCase(
      getBusinessProvinceTable.fulfilled,
      (state, { payload = [] }) => {
        state.isLoading = false

        const data = payload.map((item, index) => ({
          ...item,
          id: index + 1,
        }))
        state.ids = data.map((item) => item.id)
        state.initialIds = state.ids
        state.data = keyBy(data, 'id')
        state.dataRaw = payload
      },
    )
    builder.addCase(getBusinessProvinceTable.rejected, (state, action) => {
      state.isLoading = action.payload.isLoading
    })
  },
})

export const selectIds = (state) => state[slice.name].ids
export const selectIsLoading = (state) => state[slice.name].isLoading
export const selectCellData = (rowId, colId) => (state) =>
  state[slice.name].data[rowId][colId]
export const selectSortTable = (state) => state[slice.name].sortTable
export const selectData = (state) => state[slice.name].dataRaw

export const { resetStore, sort } = slice.actions

register(slice.name, slice.reducer)
